import { GetRequest } from '@/util/http';

export function APIFetchStaffOverview() {
  return GetRequest('/staffOverview', {});
} // APIFetchOverview

export function APIFetchStaffRanking() {
  return GetRequest('/staffRanking', {});
}
